import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="October 24, 2026" testId="privacy-page">
      <LegalSection heading="Overview">
        <p>
          This Privacy Policy explains how WorkSafeAgent LLC ("we", "us", "our") handles
          information when you visit this website or get in touch with us about WSafe AI Mobile and
          the other products in the WorkSafeAgent family. It is written in plain language and is
          governed by the laws of the State of Texas.
        </p>
      </LegalSection>

      <LegalSection heading="Information we collect">
        <p>We collect only what we need to respond to you and run this website:</p>
        <p>
          <span className="font-semibold text-slate-900">Information you give us.</span> When you
          contact us or request a pilot, you may share your name, email address, phone number,
          company, and the contents of your message.
        </p>
        <p>
          <span className="font-semibold text-slate-900">Information collected automatically.</span>{" "}
          Like most websites, our hosting and analytics tools may record basic technical details
          such as your browser type, device, pages visited, and approximate location.
        </p>
      </LegalSection>

      <LegalSection heading="How we use information">
        <p>
          We use the information we collect to answer your questions, schedule and run pilot
          conversations, provide and improve our products, and keep this website working properly.
          We do not sell your personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party services">
        <p>
          This site links to third-party services, including our scheduling provider (Calendly) and
          the websites of other WorkSafeAgent family products. When you use those services, their
          own privacy policies apply, and we encourage you to read them.
        </p>
      </LegalSection>

      <LegalSection heading="Sharing">
        <p>
          We share information only with service providers who help us operate (for example,
          website hosting and scheduling), when the law requires it, or to protect our rights. We do
          not share your information for unrelated marketing.
        </p>
      </LegalSection>

      <LegalSection heading="Your choices">
        <p>
          You can ask us to see, correct, or delete the personal information we hold about you by
          emailing us. We will respond within a reasonable time.
        </p>
      </LegalSection>

      <LegalSection heading="Security">
        <p>
          We take reasonable measures to protect the information we hold. No method of transmission
          or storage is completely secure, so we cannot guarantee absolute security.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to this policy">
        <p>
          If we change this policy, we will post the new version on this page and update the date
          above. Please check back from time to time.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions about this policy? Email us at{" "}
          <a
            href="mailto:info@wsafeai.com"
            data-testid="privacy-email-link"
            className="font-medium text-safety hover:text-safety-dark"
          >
            info@wsafeai.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
